// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyObject = Record<string, any>;

function isObject(value: unknown): value is AnyObject {
  return typeof value === 'object' && value !== null;
}

export function merge<T extends AnyObject, U extends AnyObject>(object: T, ...sources: Array<U>): T & U {
  sources.forEach((source: U) => {
    Object.keys(source).forEach((key: string) => {
      const value = source[key];
      const objectValue = object[key];
      if (Array.isArray(value)) {
        if (Array.isArray(objectValue)) {
          // @ts-ignore
          object[key] = objectValue.concat(value);
        } else {
          // @ts-ignore
          object[key] = value;
        }
      } else if (isObject(value)) {
        if (isObject(objectValue)) {
          // @ts-ignore
          object[key] = merge(objectValue, value);
        } else {
          // @ts-ignore
          object[key] = value;
        }
      } else if (value !== undefined) {
        // @ts-ignore
        object[key] = value;
      }
    });
  });
  return object as T & U;
}
